import React from 'react';

import SelectItemVertical from './SelectItemVertical/SelectItemVertical';
import MustItem from '../MustItem/MustItem';

const SelecterVertical = props => {
  if (!props.show) { return null; };

  const activeIndex = props.selected;

  const onClick = selectedIndex => {
    props.onClick(selectedIndex);
  };

  // const mustWidth = isMobile ? 32 : 32;

  const mustItem = props.must ? <MustItem minWidth={32} /> : null;

  return (
    <div className="SelectorVerticalContainer" style={{ ...props.style }} >
      <div className="SelectorVerticalTitle">
        {mustItem}
        <div className="SelectorVerticalTitleText">
          {props.title}
        </div>
      </div>
      <div className="SelectorVertical">
        {props.options.map((option, index) => (
          <SelectItemVertical
            first={index===0}
            last={index===(props.options.length-1)}
            key={index}
            title={option.title}
            desc={option.desc}
            recomend={option.recomend}
            active={activeIndex.indexOf(index) !== -1}
            onClick={() => { onClick(index) }}
            check={props.check}
            disable={props.disable}
          />
        ))}
      </div>
    </div>
  );
  };

export default SelecterVertical;
